import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useEffect, useState } from "react";
import axios from "axios";

const headers = [
  {
    key: "transfer_date",
    name: "Transfer Date",
  },
  {
    key: "warehouse_name",
    parent: "transferFrom",
    name: "Trasfer From",
  },
  {
    key: "warehouse_name",
    parent: "transferTo",
    name: "Transfer To",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "transfer_code",
    name: "Transfer ID",
  },
  {
    key: "warehouse_name",
    parent: "transferFrom",
    name: "Transfer From",
  },
  {
    key: "warehouse_name",
    parent: "transferTo",
    name: "Transfer To",
  },
  {
    key: "remark",
    name: "Remark",
  },
];

const InventoryTransferList = () => {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const [units, setUnits] = useState([]);
  useEffect(() => {
    axios
      .get(API_URL + "/unit", { withCredentials: true })
      .then((res) => setUnits(res.data.data || []))
      .catch((err) => console.error("Failed to load units", err));
  }, []);
  const detailPopupTableHeaders = [
    {
      key: "product_name",
      parent: "productDetails",
      name: "Product Name",
    },
    {
      key: "barcode",
      parent: "productDetails",
      name: "Barcode",
    },
    {
      key: "quantity",
      name: "Quantity",
    },
    {
      key: "unit_name",
      name: "SKU",
      parent: "unitDetails",

      // render: (value) => {
      //   const found = units.find((u) => u.unit_id === value);
      //   return found ? found.unit_name : value;
      // },
    },
  ];

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/inventoryTransfer",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      setSearchValue(trimmed); // Store search term
      setQuery({
        search: value.trim(),
      });
    } else {
      setSearchValue(""); // Clear search term
      setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Inventory Transfer List"
      data={data}
      headers={headers}
      detailPopupTitle="Inventory Transfer Information"
      detailPopupHeaders={detailPopupHeaders}
      detailPopupTableHeaders={detailPopupTableHeaders}
      detailPopupTableKey="transferDetails"
      idKey="transfer_id"
      endPoint="/inventoryTransfer"
      setCurrentPage={setCurrentPage}
      removeEdit={true}
      hasSearch
      hasCreate
      hasActions
      module="Warehouse"
      subModule="Inventory Transfer"
      createPath={`/warehouse/inventory-transfer/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default InventoryTransferList;
